import { useFormik } from 'formik';
import React, { useState } from 'react';
import { passwordResetFormSchema } from './formValidationSchema';
import { Button, Notification } from '@codeparva/ui-components-library';
import { UserFlowTypes } from '..';
import { UserFlowError } from './UserFlowError';
import { Icon } from '../../../utilities/icomoon-css';
import ReactTooltip from 'react-tooltip';
import { PasswordToolTip } from '../PasswordToolTip';
export const getAsterisk = () => {
  return <span className="requiredPasswordAsterisk">*</span>;
};

export const getErrorMessageIcon = () => {
  return (
    <div className="errorPasswordIconSpace">
      <Icon name="tfw-danger-triangle-cp" size={12} color="red" />
    </div>
  );
};
export const PassWordResetForm = ({
  resetPassword,
}: UserFlowTypes.TPasswordReset) => {
  const [passwordShow, setPasswordShow] = useState({
    show: [false, false, false],
  });
  const [error, setError] = React.useState<any>();
  const [hasError, setHasError] = React.useState(false);
  const [notification, setNotification] = React.useState(false);

  const togglePassword = (index: number) => {
    setPasswordShow(prevState => {
      const curState = [...prevState.show];
      curState[index] = !curState[index];
      return {
        show: curState,
      };
    });
  };
  const formik = useFormik({
    initialValues: {
      userName: '',
      newPassword: '',
      confirmPassword: '',
      oneTimeCode: '',
    },
    validationSchema: passwordResetFormSchema,

    onSubmit: values => {
      resetPassword(values, setNotification, setError, setHasError);
    },
  });
  return (
    <>
      {notification ? (
        <div className="notificationSection">
          <Notification className="notificationColor">
            Your password has been successfully reset.
            <button
              className="delete"
              onClick={() => setNotification(false)}
            ></button>
          </Notification>
        </div>
      ) : (
        <></>
      )}
      <form onSubmit={formik.handleSubmit}>
        <label className="titleColor">
          Username
          {getAsterisk()}
        </label>
        <br></br>
        <input
          id="userName"
          name="userName"
          type="email"
          placeholder="email id"
          className="inputPasswordResetField"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.userName}
        />
        {formik.touched.userName && formik.errors.userName ? (
          <div className="errorPasswordSection">
            {getErrorMessageIcon()}

            <div className="errorPasswordMessage content1">
              {formik.errors.userName}
            </div>
          </div>
        ) : (
          <></>
        )}
        <div className="passwordToolTipLabel">
          <label className="titleColor">
            Password
            {getAsterisk()}
          </label>

          <span
            data-tip
            data-for="passwordTip"
            className="is-flex toolTipSection"
          >
            <Icon name="tfw-danger-circle-cp" size={18}>
              {' '}
            </Icon>
            <ReactTooltip
              className="passwordTipClass"
              id="passwordTip"
              type="light"
              effect="solid"
              backgroundColor="white"
              getContent={PasswordToolTip}
            ></ReactTooltip>
          </span>
          <br></br>
        </div>
        <div className="control has-icons-right">
          <input
            id="newPassword"
            name="newPassword"
            type={passwordShow.show[0] ? 'text' : 'password'}
            placeholder="New Password"
            className="is-flex  inputPasswordResetField"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.newPassword}
          />
          <span className="icon is-small is-right">
            <span className="is-clickable" onClick={() => togglePassword(0)}>
              {passwordShow.show[0] ? (
                <Icon name="tfw-show-bold-cp" color="black" size={14} />
              ) : (
                <Icon name="tfw-hide-bold-cp" color="black" size={14} />
              )}
            </span>
          </span>
        </div>
        {formik.touched.newPassword && formik.errors.newPassword ? (
          <div className="errorPasswordSection">
            {getErrorMessageIcon()}

            <div className="errorPasswordMessage content1">
              {formik.errors.newPassword}
            </div>
          </div>
        ) : (
          <></>
        )}

        <label className="titleColor">
          Confirm Password
          {getAsterisk()}
        </label>
        <br></br>
        <div className="control has-icons-right">
          <input
            id="confirmPassword"
            name="confirmPassword"
            type={passwordShow.show[1] ? 'text' : 'password'}
            placeholder="Re-enter Password"
            className="is-flex  inputPasswordResetField"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.confirmPassword}
          />
          <span className="icon is-small is-right">
            <span className="is-clickable" onClick={() => togglePassword(1)}>
              {passwordShow.show[1] ? (
                <Icon name="tfw-show-bold-cp" color="black" size={14} />
              ) : (
                <Icon name="tfw-hide-bold-cp" color="black" size={14} />
              )}
            </span>
          </span>
        </div>
        {formik.touched.confirmPassword && formik.errors.confirmPassword ? (
          <div className="errorPasswordSection">
            {getErrorMessageIcon()}

            <div className="errorPasswordMessage content1">
              {formik.errors.confirmPassword}
            </div>
          </div>
        ) : (
          <></>
        )}

        <label className="titleColor">
          Temporary Code
          {getAsterisk()}
        </label>
        <br></br>
        <div className="control has-icons-right">
          <input
            id="oneTimeCode"
            name="oneTimeCode"
            type={passwordShow.show[2] ? 'text' : 'password'}
            placeholder="Enter Temp Code"
            className="is-flex  inputPasswordResetField"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.oneTimeCode}
          />
          <span className="icon is-small is-right">
            <span className="is-clickable" onClick={() => togglePassword(2)}>
              {passwordShow.show[2] ? (
                <Icon name="tfw-show-bold-cp" color="black" size={14} />
              ) : (
                <Icon name="tfw-hide-bold-cp" color="black" size={14} />
              )}
            </span>
          </span>
        </div>
        {formik.touched.oneTimeCode && formik.errors.oneTimeCode ? (
          <div className="errorPasswordSection">
            {getErrorMessageIcon()}

            <div className="errorPasswordMessage content1">
              {formik.errors.oneTimeCode}
            </div>
          </div>
        ) : (
          <></>
        )}
        {UserFlowError(hasError, error)}
        <div className="ctaButton">
          <Button
            className="cp-primary-button-highlighted buttonColor"
            disabled={!formik.isValid || !formik.dirty}
          >
            Reset
          </Button>
        </div>
      </form>
    </>
  );
};
